import { render, staticRenderFns } from "./ImportVolumeCoverPdfDialog.vue?vue&type=template&id=65c86f82"
import script from "./ImportVolumeCoverPdfDialog.vue?vue&type=script&lang=js"
export * from "./ImportVolumeCoverPdfDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportVolumeCoverPdfDialog.vue?vue&type=style&index=0&id=65c86f82&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports